import React from "react";

export type MainScreen =
  | "main"
  | "instructions"
  | "payment-methods"
  | "app-login";

export function requireContext<T>(value: T | null, name: string): T {
  if (!value) {
    throw new Error(`${name} must be used within its provider`);
  }

  return value;
}

export type WithChildren = React.PropsWithChildren;
